module.exports = __webpack_public_path__ + "static/media/Empanelment-four.9dd2ab31.png";